import React, { useEffect, useState } from 'react';
import ZLChartRow from './zlChartRow';
import './main.css';
import chartBackground from './images/ZLvsWalkmeChart-2.svg';


// Landing Pages Section 1D
function ZLChart(props) {
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        const chart = new Image();
        chart.src = chartBackground;
        chart.onload = () => {
            setLoaded(true);
        };
    });

    if (loaded) {
        return (
            <div className="ziplyne-chart">
                <img alt="" src={chartBackground} />
                <div className="ziplyne-chart__content">
                    <ZLChartRow title={"Excel Integration"} checkWalkme={true} />
                    <ZLChartRow title={"Branching Logic"} checkWalkme={true} />
                    <ZLChartRow title={"Cross Platforms"} checkWalkme={true} />
                    <ZLChartRow title={"User Enabled Screenshots"} checkWalkme={false} />
                    <ZLChartRow title={"Customizable Shareable Links"} checkWalkme={false} />
                    <ZLChartRow title={"Connecting Guides"} checkWalkme={false} />
                    <ZLChartRow title={"Step Mirroring"} checkWalkme={false} />
                    <ZLChartRow title={"Automated Form Selection"} checkWalkme={false} />
                    <ZLChartRow title={"Guide Monitoring"} checkWalkme={false} />
                </div>
            </div>
        );
    } else {
        return <div className="ziplyne-chart" />
    }

}

export default ZLChart;